import React from 'react';

import { FallbackProps } from 'react-error-boundary';
import { Col, Container, Row } from 'reactstrap';

import errorImage from 'assets/images/error-img.png';
import { strings } from 'constants/index';

const ClientError: React.FC<FallbackProps> = ({ error }: FallbackProps) => {
  return (
    <React.Fragment>
      <div className="my-5 pt-5">
        <Container>
          <Row>
            <Col>
              <div className="mb-5 d-flex align-items-center flex-column">
                <h4 className="text-uppercase">{strings.Site.ErrorOccurred}</h4>
                <div className="d-flex align-self-start">
                  <details>
                    <div>{error?.toString()}</div>
                  </details>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col
              md={8}
              xl={6}>
              <div>
                <img
                  alt=""
                  className="img-fluid"
                  src={errorImage}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ClientError;
